/**
 * 「Submit Order」= 把采购清单发给 TORENA 的 ERP。**不走 Shopify 结账。**
 *
 * ── 2026-09-02 重写。之前这里只是弹个框然后照旧提交表单（走 /checkout）──
 * May：「shopify 接到清单后到 erp 收到购物车清单，然后 PI、订单、物流反馈给
 * shopify 买家账户」。所以现在点下去是真的把清单发到
 * `app.torenajewelry.com/api/shopify/order-intake`，ERP 那边落成一张询价单。
 *
 * ⚠️ **为什么不走结账**：线上不收款。走结账要开支付方式、配运费区间，
 * 而运费在下单那一刻根本算不出来（目的地、体积、空运还是海运都要谈）。
 * 买家点这个按钮表达的是采购意向，中间还隔着核价、PI、电汇三步。
 * Shopify 那张订单等她发了 PI 再由 ERP 建，那时候买家在 /account 里就看得到了。
 *
 * ⚠️ **只发 SKU 和数量。** 价格一律由 ERP 自己按 SKU 查 ——
 * 这里发一个金额过去，改一个 JS 变量就能用 $0.01 下单。
 *
 * ⚠️ 这个脚本挂在 `layout/theme.liquid`，**不是订单页那个 section**。
 * 右拉抽屉是全站渲染的（theme.liquid 第 379 行），抽屉里那个提交按钮
 * 也带 `data-torena-submit`；脚本只在订单页加载的话，在商品页点抽屉里的提交
 * 会绕过这里直接跳 /checkout。（同一个坑 torena-cart.css 在 8-27 踩过一次。）
 */
(function () {
  /**
   * ⚠️ 提交那一刻 **Shopify 不发任何邮件** —— 它的订单确认邮件要等 ERP 建单
   * （也就是她发 PI 的时候）才触发。所以「接下来会发生什么」必须在这个框里先讲完，
   * 否则买家点完提交就断片了：不知道什么时候收到 PI、什么时候付款、什么时候拿质检报告。
   * （May 2026-09-03 提的就是这件事。）
   * 这四步和 Shopify 订单确认邮件里那段是**同一套口径**，改一处要两处一起改。
   */
  var WA_LINK = 'https://wa.me/8618358002390';
  var T = {
    title: 'Send this order list to TORENA?',
    body:
      'A TORENA buyer will check stock and send your proforma invoice within 12 hours. ' +
      'Nothing is charged online — payment is by bank transfer (Airwallex) or PayPal after you approve the PI. ' +
      'We quality-check within 72 hours of payment and ship within 24 hours of passing QC.',
    confirm: 'Send the order',
    cancel: 'Keep editing',
    sending: 'Sending…',
    okTitle: 'Order list received',
    okBody: 'Your reference is {ref}. Here is what happens next:',
    /**
     * ⚠️ 「12 小时」是**全站唯一的响应承诺**（May 2026-09-03 统一的，出 PI 也算在内）。
     *    页脚写的就是 12 小时，这里原来写 1 个工作小时 —— 两个数摆在同一个网站上，
     *    买家会按小的那个记。她一个人跨时区，1 小时是收不回的硬承诺。
     * ⚠️ 质检报告**上传到 Shopify 订单里**（她 2026-09-03 定的），
     *    所以这里要指路到账户，不能只说「随单据发」——买家不知道去哪看。
     */
    okSteps: [
      'Proforma invoice — within 12 hours. It confirms stock, freight and the final total.',
      'Payment — 100% in advance by bank transfer (Airwallex) or PayPal. Details are on the PI. Nothing is charged on this website.',
      'QC report — uploaded to this order in your account before we ship, so you can check the goods first.',
      'Shipping — within 24 hours of your order passing quality check (QC is done within 72 hours of payment). You will get a tracking link by email.',
    ],
    okContact: 'Questions at any point: info@torenajewelry.com or WhatsApp 0086 18358002390.',
    /**
     * ⚠️ 不能写「在 My Orders 里跟踪这张单」—— Shopify 那张单要**付款到账**才建，
     *    提交完立刻点进去是空的，买家会以为提交失败了。所以说清楚「付款之后」。
     */
    trackNote: 'Once your payment clears, you can follow this order step by step in',
    trackLink: 'My Orders',
    close: 'Done',
    failTitle: "We couldn't send your list",
    retry: 'Try again',
    needLogin: 'Please log in with your approved wholesale account to submit an order list.',
    short: 'Minimum order is {moq}. Your list comes to {total} — add {gap} more.',
    offline: "We couldn't reach TORENA just now. Please check your connection and try again, or message us on WhatsApp.",
  };

  var openedAt = Date.now();

  /**
   * 国家 = Shopify 地址接口认的 CountryCode 全集（2026-09-10 内省取的，去掉了 ZZ「未知」）。
   * ⚠️ 名字不写死：用浏览器自带的 Intl.DisplayNames 按页面语言显示（德语页就是 Deutschland），
   *    发给 ERP 的永远是两位代码 —— Shopify 和运费分区都只认代码。
   */
  var COUNTRY_CODES = ('AF,AX,AL,DZ,AD,AO,AI,AG,AR,AM,AW,AC,AU,AT,AZ,BS,BH,BD,BB,BY,BE,BZ,BJ,BM,BT,BO,BA,BW,BV,BR,IO,BN,BG,BF,BI,KH,CA,CV,BQ,KY,CF,TD,CL,CN,CX,CC,CO,KM,CG,CD,CK,CR,HR,CU,CW,CY,CZ,CI,DK,DJ,DM,DO,EC,EG,SV,GQ,ER,EE,SZ,ET,FK,FO,FJ,FI,FR,GF,PF,TF,GA,GM,GE,DE,GH,GI,GR,GL,GD,GP,GT,GG,GN,GW,GY,HT,HM,VA,HN,HK,HU,IS,IN,ID,IR,IQ,IE,IM,IL,IT,JM,JP,JE,JO,KZ,KE,KI,KP,XK,KW,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MO,MG,MW,MY,MV,ML,MT,MQ,MR,MU,YT,MX,MD,MC,MN,ME,MS,MA,MZ,MM,NA,NR,NP,NL,AN,NC,NZ,NI,NE,NG,NU,NF,MK,NO,OM,PK,PS,PA,PG,PY,PE,PH,PN,PL,PT,QA,CM,RE,RO,RU,RW,BL,SH,KN,LC,MF,PM,WS,SM,ST,SA,SN,RS,SC,SL,SG,SX,SK,SI,SB,SO,ZA,GS,KR,SS,ES,LK,VC,SD,SR,SJ,SE,CH,SY,TW,TJ,TZ,TH,TL,TG,TK,TO,TT,TA,TN,TR,TM,TC,TV,UG,UA,AE,GB,US,UM,UY,UZ,VU,VE,VN,VG,WF,EH,YE,ZM,ZW').split(',');
  /**
   * 不用邮编的国家/地区 → 邮编一栏变选填。
   * ⚠️ 海湾（AE / QA）、香港、澳门都在里面：邮编写成必填，这些市场的买家会被卡在提交这一步。
   */
  var NO_ZIP = ',AE,AG,AO,AW,BF,BI,BJ,BO,BS,BW,BZ,CD,CF,CG,CI,CK,CM,DJ,DM,ER,FJ,GA,GD,GH,GM,GN,GQ,GY,HK,JM,KI,KM,KN,KP,LC,ML,MO,MR,MW,NR,NU,QA,RW,SB,SC,SL,SO,SR,SS,ST,SY,TD,TF,TG,TK,TL,TO,TT,TV,UG,VU,YE,ZW,';

  /**
   * 收货地址（May 2026-09-10）。
   *
   * 她的原话：「如果没有获取到，也可以让买家自行在这里填写，再传回到 erp，
   * 总之买家提交过 1 次后不要重复让买家提交」。
   *
   * · 已经有地址（他上次填过、或她从 WhatsApp 问到录进 ERP 后同步过来的）→
   *   只显示一行「Ship to …」+ Change，**不让他再填一遍**
   * · 没有 → 表单填一次。ERP 存档并写回 Shopify，下次就是上面那种
   *
   * ⚠️ 地址是**必填**的：提交这一刻是唯一确定他在看的时候，
   *    而且没有邮编算不出运费分区（澳大利亚同一重量 3 个区差一倍价），PI 出不准。
   * ⚠️ `edited` 只在「有预填、他点了 Change、而且真动过」时才是 true ——
   *    服务端只有这时才覆盖档案。第一次填不算改：档案里要是已经有她 WhatsApp
   *    问到的那份（只是还没同步到网站），不能被悄悄盖掉。
   * ⚠️ 全部用 textContent / value 写入，不拼 innerHTML —— 预填值是买家自己输过的。
   */
  function addressBlock(pre) {
    var complete = !!(pre && pre.address1 && pre.country && (pre.city || pre.zip));
    var edited = false;
    var names = null;
    try { names = new Intl.DisplayNames([document.documentElement.lang || 'en', 'en'], { type: 'region' }); } catch (e) {}
    function countryName(code) { try { return (names && names.of(code)) || code; } catch (e) { return code; } }

    var box = document.createElement('div');
    box.className = 'torena-ship';
    var head = document.createElement('p');
    head.className = 'torena-ship__head';
    var summary = document.createElement('p');
    summary.className = 'torena-ship__summary';
    var change = document.createElement('button');
    change.type = 'button';
    change.className = 'torena-ship__change';
    change.textContent = 'Change';
    var hint = document.createElement('p');
    hint.className = 'torena-ship__hint';
    hint.textContent = "You'll only need to do this once — we'll use it for your next orders too.";
    var form = document.createElement('div');
    form.className = 'torena-ship__form';
    var err = document.createElement('p');
    err.className = 'torena-ship__err';
    err.setAttribute('role', 'alert');
    err.hidden = true;

    var FIELDS = [
      { k: 'address1', label: 'Street address', auto: 'address-line1', full: true },
      { k: 'address2', label: 'Apartment, suite, unit (optional)', auto: 'address-line2', full: true },
      { k: 'city', label: 'City', auto: 'address-level2' },
      { k: 'province', label: 'State / Province (optional)', auto: 'address-level1' },
      { k: 'zip', label: 'Postcode', auto: 'postal-code' },
      { k: 'country', label: 'Country', auto: 'country' },
      { k: 'company', label: 'Company name (optional)', auto: 'organization', full: true },
      { k: 'phone', label: 'Phone for the courier (optional)', auto: 'tel', type: 'tel', full: true },
    ];
    var inputs = {};
    var zipSpan = null;
    function val(k) { return ((inputs[k] && inputs[k].value) || '').trim(); }
    function zipOptional() { return NO_ZIP.indexOf(',' + val('country') + ',') >= 0; }
    function syncZipLabel() { if (zipSpan) zipSpan.textContent = zipOptional() ? 'Postcode (optional)' : 'Postcode'; }

    FIELDS.forEach(function (f) {
      var label = document.createElement('label');
      label.className = 'torena-ship__field' + (f.full ? ' torena-ship__field--full' : '');
      var span = document.createElement('span');
      span.textContent = f.label;
      if (f.k === 'zip') zipSpan = span;
      label.appendChild(span);
      var el;
      if (f.k === 'country') {
        el = document.createElement('select');
        var blank = document.createElement('option');
        blank.value = '';
        blank.textContent = 'Select country';
        el.appendChild(blank);
        COUNTRY_CODES.map(function (c) { return { c: c, n: countryName(c) }; })
          .sort(function (a, b) { return a.n.localeCompare(b.n); })
          .forEach(function (o) {
            var opt = document.createElement('option');
            opt.value = o.c;
            opt.textContent = o.n;
            el.appendChild(opt);
          });
      } else {
        el = document.createElement('input');
        el.type = f.type || 'text';
      }
      el.name = 'ship_' + f.k;
      el.setAttribute('autocomplete', 'shipping ' + f.auto);
      el.value = (pre && pre[f.k]) || '';
      var touched = function () {
        if (complete) edited = true;
        err.hidden = true;
        if (f.k === 'country') syncZipLabel();
      };
      el.addEventListener('input', touched);
      el.addEventListener('change', touched);
      inputs[f.k] = el;
      label.appendChild(el);
      form.appendChild(label);
    });
    syncZipLabel();

    /**
     * 一行地址。⚠️ 城市 / 州已经写在街道那一格里的不再重复（她 2026-09-13 截图：
     * 「405 Hilgard Avenue, Los Angeles, CA, Los Angeles CA 90095」）。和 ERP 打印 PI 同一条规则：
     * 按**整词**比，「CA」不能因为「Casablanca」里有 ca 就算写过了。
     */
    function fmt(o) {
      var inStreet = function (part) {
        if (!part || !o.address1) return false;
        var esc = String(part).trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return new RegExp('(^|[\\s,])' + esc + '([\\s,]|$)', 'i').test(o.address1);
      };
      var tail = [inStreet(o.city) ? '' : o.city, inStreet(o.province) ? '' : o.province].filter(Boolean).join(' ');
      var street = [o.address1, o.address2].filter(Boolean).join(', ');
      var line = tail
        ? [street, [tail, o.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ')
        : [street, o.zip].filter(Boolean).join(' ');
      return [o.company, line, countryName(o.country)].filter(Boolean).join(', ');
    }

    /**
     * 「Use this address / Cancel」（她 2026-09-13：「网页编辑我选择了 change，保存了还是没有变化」）。
     * 原来点 Change 只是展开表单、没有保存的动作，改完看不出生效没有。现在点 Use this address 收回成一行、
     * 显示新地址 + 一句话（这张单按新地址发；已保存的地址要我们确认后才改 —— 网站上的改动不直接覆盖档案）；
     * Cancel 恢复原来的。第一次填（没有预填）不显示这两个按钮，填完直接提交。
     */
    var actions = document.createElement('div');
    actions.className = 'torena-ship__actions';
    var useBtn = document.createElement('button');
    useBtn.type = 'button';
    useBtn.className = 'torena-ship__use';
    useBtn.textContent = 'Use this address';
    var cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'torena-ship__change';
    cancelBtn.textContent = 'Cancel';
    actions.appendChild(useBtn);
    actions.appendChild(cancelBtn);
    actions.hidden = !complete;
    form.appendChild(actions);
    useBtn.addEventListener('click', function () {
      var bad = problems();
      if (bad) { err.textContent = bad; err.hidden = false; return; }
      summary.textContent = fmt(read());
      summary.hidden = false;
      change.hidden = false;
      form.hidden = true;
      hint.textContent = edited
        ? 'This order will ship to this address. Your saved address is updated once our team confirms the change.'
        : 'No changes — we will use your saved address.';
      hint.hidden = false;
    });
    cancelBtn.addEventListener('click', function () {
      FIELDS.forEach(function (f) { inputs[f.k].value = (pre && pre[f.k]) || ''; });
      syncZipLabel();
      edited = false;
      err.hidden = true;
      summary.textContent = fmt(pre);
      summary.hidden = false;
      change.hidden = false;
      form.hidden = true;
      hint.hidden = true;
    });

    function showForm() {
      summary.hidden = true;
      change.hidden = true;
      form.hidden = false;
      /**
       * ⚠️ 已保存的地址在网站上改**不会直接生效**（2026-09-11：防别人冒充买家改收货地址，
       *    改动由她确认后在 ERP 里改）。这句话必须当面说 —— 不说的话他以为改好了，
       *    货却按旧地址发。
       */
      if (complete) {
        hint.textContent = "Changes to a saved address are confirmed by our team before they're used for shipping.";
        hint.hidden = false;
      }
    }
    if (complete) {
      head.textContent = 'Ship to';
      summary.textContent = fmt(pre);
      form.hidden = true;
      hint.hidden = true;
      change.addEventListener('click', showForm);
    } else {
      head.textContent = 'Where should we ship this order?';
      summary.hidden = true;
      change.hidden = true;
    }
    box.appendChild(head);
    box.appendChild(summary);
    box.appendChild(change);
    box.appendChild(hint);
    box.appendChild(form);
    box.appendChild(err);

    function problems() {
      var miss = [];
      if (!val('address1')) miss.push('street address');
      if (!val('city')) miss.push('city');
      if (!val('country')) miss.push('country');
      if (!val('zip') && !zipOptional()) miss.push('postcode');
      return miss.length ? 'Please add your ' + miss.join(', ') + ' so we can quote freight and ship this order.' : '';
    }
    function read() {
      var o = {};
      Object.keys(inputs).forEach(function (k) { o[k] = val(k); });
      return o;
    }
    return {
      el: box,
      validate: function () {
        var m = problems();
        if (m && form.hidden) showForm();     // 预填的那份缺了一格（少见）→ 展开让他补上
        return m;
      },
      showError: function (m) { err.textContent = m; err.hidden = false; },
      read: read,
      edited: function () { return edited; },
    };
  }

  function ctx() {
    var el = document.getElementById('torena-submit-ctx');
    if (!el) return {};
    try { return JSON.parse(el.textContent) || {}; } catch (e) { return {}; }
  }

  function money(cents) {
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  /**
   * 一个框，两种用途：确认 / 结果。
   * 文案全部用 textContent 写进去，不拼 innerHTML —— 里面会出现服务端返回的
   * 错误信息和买家自己填的内容，拼进 HTML 就是一个注入口。
   */
  function dialog(opts) {
    var old = document.querySelector('.torena-modal');
    if (old) old.remove();

    var wrap = document.createElement('div');
    wrap.className = 'torena-modal';
    wrap.innerHTML =
      '<div class="torena-modal__panel" role="dialog" aria-modal="true" aria-labelledby="torena-modal-t">' +
      '<h2 class="torena-modal__title" id="torena-modal-t"></h2>' +
      '<p class="torena-modal__body"></p>' +
      '<div class="torena-modal__ctas">' +
      '<button type="button" class="torena-modal__cancel button button--secondary"></button>' +
      '<button type="button" class="torena-modal__ok button"></button>' +
      '</div></div>';

    var titleEl = wrap.querySelector('.torena-modal__title');
    var bodyEl = wrap.querySelector('.torena-modal__body');
    var okBtn = wrap.querySelector('.torena-modal__ok');
    var cancelBtn = wrap.querySelector('.torena-modal__cancel');

    titleEl.textContent = opts.title;
    bodyEl.textContent = opts.body;

    // 「接下来会发生什么」四步。⚠️ 每一条都用 textContent 写进去 ——
    // 这个框里会出现服务端返回的文字，拼 innerHTML 就是一个注入口。
    if (opts.steps && opts.steps.length) {
      var ol = document.createElement('ol');
      ol.className = 'torena-modal__steps';
      opts.steps.forEach(function (s) {
        var li = document.createElement('li');
        li.textContent = s;
        ol.appendChild(li);
      });
      bodyEl.insertAdjacentElement('afterend', ol);
    }
    if (opts.contact) {
      var p = document.createElement('p');
      p.className = 'torena-modal__contact';
      // 号码做成可点的 wa.me 链接 —— 手机上买家不用手抄
      var wa = document.createElement('a');
      wa.href = WA_LINK;
      wa.target = '_blank';
      wa.rel = 'noopener';
      wa.textContent = 'WhatsApp 0086 18358002390';
      p.appendChild(document.createTextNode('Questions at any point: info@torenajewelry.com · '));
      p.appendChild(wa);
      (ol || bodyEl).insertAdjacentElement('afterend', p);
    }
    // 额外的一块（确认框里的收货地址 / 成功框里的 My Orders 说明），永远放在按钮正上方
    if (opts.extra) {
      var ctas = wrap.querySelector('.torena-modal__ctas');
      ctas.parentNode.insertBefore(opts.extra, ctas);
    }
    okBtn.textContent = opts.confirm || T.close;
    if (opts.cancel) cancelBtn.textContent = opts.cancel;
    else cancelBtn.remove();

    function close() {
      wrap.remove();
      document.removeEventListener('keydown', onKey);
      if (opts.onClose) opts.onClose();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    if (opts.cancel) cancelBtn.addEventListener('click', close);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) close(); });
    okBtn.addEventListener('click', function () {
      if (opts.onConfirm) opts.onConfirm({ setBusy: setBusy, close: close });
      else close();
    });
    function setBusy(on, label) {
      okBtn.disabled = !!on;
      okBtn.textContent = on ? (label || T.sending) : (opts.confirm || T.close);
      if (cancelBtn.parentNode) cancelBtn.disabled = !!on;
    }

    document.addEventListener('keydown', onKey);
    document.body.appendChild(wrap);
    okBtn.focus();
    return { close: close, setBusy: setBusy, body: bodyEl, title: titleEl };
  }

  /**
   * 「我的订单」页右边那块补全资料时复用同一个地址框（国家列表、必填规则、不用邮编的地区都一致）。
   * 那一页的脚本是 inline 的、比这个 defer 脚本先跑，所以它只在**点按钮时**才取这个函数。
   */
  window.torenaAddressBlock = addressBlock;

  function getCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
      { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/clear.js' : '/cart/clear.js',
      { method: 'POST', headers: { Accept: 'application/json' } });
  }

  function submit(cart, c, ui, addr) {
    ui.setBusy(true);
    return fetch(c.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      // ⚠️ 只发 SKU 和数量。金额、商品名、价格一概不发 —— ERP 自己查
      body: JSON.stringify({
        customer_id: c.customerId,
        note: cart.note || '',
        elapsed: Date.now() - openedAt,
        website: '',                       // 蜜罐：真人这一格永远是空的
        items: cart.items.map(function (i) { return { sku: i.sku, qty: i.quantity }; }),
        ship: addr ? addr.read() : null,
        ship_edited: addr ? addr.edited() : false,
      }),
    })
      .then(function (r) { return r.json().then(function (j) { return { status: r.status, body: j }; }); })
      .then(function (res) {
        ui.setBusy(false);
        if (res.body && res.body.ok) {
          // 清空购物车放在**成功之后**。反过来的话网络一断，单没发出去、车也空了
          return clearCart().then(function () {
            ui.close();
            var track = null;
            if (c.ordersUrl) {
              track = document.createElement('p');
              track.className = 'torena-modal__track';
              track.appendChild(document.createTextNode(T.trackNote + ' '));
              var a = document.createElement('a');
              a.href = c.ordersUrl;
              a.textContent = T.trackLink;
              track.appendChild(a);
              track.appendChild(document.createTextNode('.'));
            }
            dialog({
              extra: track,
              title: T.okTitle,
              body: T.okBody.replace('{ref}', res.body.reference || '—')
                + (res.body.unavailable && res.body.unavailable.length
                  ? ' (These items are not available right now and were not included: '
                    + res.body.unavailable.join(', ') + '.)'
                  : ''),
              steps: T.okSteps,
              contact: true,
              onClose: function () { window.location.reload(); },
            });
          });
        }
        ui.close();
        dialog({ title: T.failTitle, body: (res.body && res.body.error) || ('HTTP ' + res.status) });
      })
      .catch(function () {
        ui.setBusy(false);
        ui.close();
        dialog({ title: T.failTitle, body: T.offline });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-torena-submit]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    e.stopPropagation();

    var c = ctx();
    if (!c.endpoint) return;                       // 上下文没渲染出来就什么都不做，别把买家卡在一个坏按钮上
    if (!c.customerId || !c.approved) {
      dialog({ title: T.failTitle, body: T.needLogin });
      return;
    }

    btn.disabled = true;
    getCart().then(function (cart) {
      btn.disabled = false;
      if (!cart || !cart.items || !cart.items.length) return;

      // 起订额：和页面上那条进度条同一个数（moqCents 由 Liquid 传进来）
      var moq = c.moqCents || 0;
      if (moq && cart.items_subtotal_price < moq) {
        dialog({
          title: T.failTitle,
          body: T.short.replace('{moq}', money(moq))
            .replace('{total}', money(cart.items_subtotal_price))
            .replace('{gap}', money(moq - cart.items_subtotal_price)),
        });
        return;
      }

      // 地址框建不出来（极老的浏览器）也别挡提交 —— 没地址的清单服务端照收，她在 WhatsApp 上补问
      var addr = null;
      try { addr = addressBlock(c.ship); } catch (e) { addr = null; }
      dialog({
        title: T.title,
        body: T.body,
        confirm: T.confirm,
        cancel: T.cancel,
        extra: addr ? addr.el : null,
        onConfirm: function (h) {
          if (addr) {
            var m = addr.validate();
            if (m) { addr.showError(m); return; }
          }
          submit(cart, c, h, addr);
        },
      });
    }).catch(function () {
      btn.disabled = false;
      dialog({ title: T.failTitle, body: T.offline });
    });
  }, true);  // 捕获阶段拦 —— 表单自己的 submit 监听器跑得比冒泡早
})();
